import { DEFAULT_SORT, emptyFilters, filtersFromSearchParams, filtersToSearchParams, sortFromParam, sortToParam } from '@mona-roadmap/domain';
import type { FilterState, SortState, ViewMode } from '@mona-roadmap/domain';

export interface UrlState {
  view: ViewMode;
  filters: FilterState;
  sort: SortState;
}

const VIEW_PARAM = 'view';
const SORT_PARAM = 'sort';

export function parseUrlState(search: string): UrlState {
  const p = new URLSearchParams(search);
  return { view: p.get(VIEW_PARAM) === 'epic' ? 'by-epic' : 'by-goal', filters: filtersFromSearchParams(p), sort: sortFromParam(p.get(SORT_PARAM)) };
}

/** Returns the new query string (with leading ?, or empty). Unrelated params are preserved. */
export function buildSearch(current: string, state: UrlState): string {
  const p = new URLSearchParams(current);
  filtersToSearchParams(state.filters, p);
  if (state.view === 'by-epic') p.set(VIEW_PARAM, 'epic');
  else p.delete(VIEW_PARAM);
  const sort = sortToParam(state.sort);
  if (sort) p.set(SORT_PARAM, sort);
  else p.delete(SORT_PARAM);
  const s = p.toString();
  return s ? `?${s}` : '';
}

export const initialUrlState = (): UrlState => (typeof window === 'undefined' ? { view: 'by-goal', filters: emptyFilters(), sort: DEFAULT_SORT } : parseUrlState(window.location.search));
